import { render, staticRenderFns } from "./ToDoMsg.vue?vue&type=template&id=6f0bedcf&scoped=true"
import script from "./ToDoMsg.vue?vue&type=script&lang=js"
export * from "./ToDoMsg.vue?vue&type=script&lang=js"
import style0 from "./ToDoMsg.vue?vue&type=style&index=0&id=6f0bedcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bedcf",
  null
  
)

export default component.exports